export default __webpack_public_path__ + "images/RNG.85ecee3.png";